import { render, staticRenderFns } from "./ModalAddLicense.vue?vue&type=template&id=3b9f1f4a&"
import script from "./ModalAddLicense.vue?vue&type=script&lang=ts&"
export * from "./ModalAddLicense.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAddLicense.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports